<template>
    <div>
        <span class="custom-info-item__label">{{ field.label }}</span>
        <span v-if="!isPicture" class="custom-info-item__value">
            {{ displayValue | formatting(field.type,field.currency) }}
            <span v-if="isTextArea && this.fieldValueOverflows">
                <i><a href="javascript:void(0)" v-popover:textAreaFullContent.left> {{ this.$t('LBL_MORE') }}</a></i>
                <popover name="textAreaFullContent" event="click" width="500">
                    {{ field.displayValue }}
                </popover>
            </span>
        </span>
        <ini-attachment v-if="isPicture" :name="field.displayValue.name" :ext="field.displayValue.ext" :size="field.displayValue.size" :id="field.displayValue.id"/>
       </div>
</template>



<script>
    import IniAttachment from '@/components/Attachment'
    export default {
        components: {
            IniAttachment
        },
        data: () => {
            return {
                maxLengthToDisplay: 150
            }
        },

        props: {
            field: {
                label: '',
                displayValue: '',
                type: '',
            }
        },
        computed: {
            displayValue() {
                if(this.isTextArea && this.fieldValueOverflows) {
                    return this.field.displayValue.slice(0, this.maxLengthToDisplay) + '...'
                }
                if(this.isBoolean) {
                    return this.field.value
                }
                return this.field.displayValue
            },

            isTextArea() {
                return ['text', 'string'].includes(this.field.type)
            },

            isPicture() {
                return this.field.type == 'picture'
            },

            isBoolean() {
                return this.field.type == 'boolean'
            },

            fieldValueOverflows() {
                return this.field.displayValue.length > this.maxLengthToDisplay
            }
        }
    }
</script>
